import {Component, inject, OnInit} from '@angular/core';
import {FormBuilder, ReactiveFormsModule, Validators} from '@angular/forms';
import {Button} from 'primeng/button';
import {DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import {TranslocoPipe} from '@jsverse/transloco';
import {FormFieldComponent} from '../../../../../../shared/components/inputs/form-field/form-field.component';

@Component({
  imports: [ReactiveFormsModule, Button, TranslocoPipe, FormFieldComponent],
  templateUrl: './project-conclusion-decline-dialog.component.html',
})
export class ProjectConclusionDeclineDialogComponent implements OnInit {
  private readonly fb = inject(FormBuilder);
  public ref = inject(DynamicDialogRef);
  public config = inject(DynamicDialogConfig);

  protected readonly message = this.config.data?.message;

  readonly form = this.fb.group({
    comment: [undefined as string | undefined, [Validators.required]],
  });

  ngOnInit(): void {
    if (this.config.data?.comment) {
      this.form.patchValue({
        comment: this.config.data.comment,
      });
    }
  }

  onSave(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.ref.close({
      comment: this.form.getRawValue().comment,
      confirmed: true,
    });
  }

  onHideDialog(): void {
    this.ref.close({
      comment: this.form.getRawValue().comment,
      confirmed: false,
    });
  }
}
